import AxiosInterceptor from 'api/interceptor';

const machine = new AxiosInterceptor();

export default {
  get(){
    return machine.get('/machine');
  },
  find(id) {
    return machine.get('/machine/' + id);
  },
  create(inputs) {
    return machine.post('/machine', {
      'name' : inputs.name,
      'address': inputs.address,
      'latlng' : inputs.latlng,
      'info': inputs.info,
      'area_id' : inputs.area_id
    });
  },
  update(id,inputs) {
    return machine.put('/machine/' + id + '/update' , {
      'name' : inputs.name,
      'address': inputs.address,
      'latlng' : inputs.latlng,
      'info': inputs.info,
      'area_id' : inputs.area_id
    });
  },
  delete(id) {
    return machine.delete('/machine/'+id +'/delete');
  },
  getArea(){
    return machine.get('/machine-area');
  },
  findArea(id){
    return machine.get('/machine-area/' + id);
  },
  createArea(inputs) {
    return machine.post('/machine-area', {
      'name' : inputs.name,
      'description': inputs.description
    });
  },
  updateArea(id,inputs) {
    return machine.put('/machine-area/' + id +'/update', {
      'name' : inputs.name,
      'description': inputs.description
    });
  },
  deleteArea(id) {
    return machine.delete('/machine-area/'+id + '/delete');
  },
};